// extracted by css-extract-rspack-plugin
export default {"cpvMiniChart":"XvUKVDkz0pUFHVxY__cpvMiniChart___","chartBars":"eoVZD0d9YKAK0kmn__chartBars___","title":"hgs2zFXnQOsNmGyh__title___"};